module Formatting

let formatAmount  (amount:decimal) : string = 
    // Format decimal with narrow no break space as group separator
    amount.ToString("#,#").Replace(",", "\u202F")

let formatAmountWithDecimals  (amount:decimal) : string = 
    // Format decimal with narrow no break space as group separator
    amount.ToString("#,#.##").Replace(",", "\u202F").Replace(".", ",")